module.exports = __webpack_public_path__ + "img/d1.8d409d88.jpg";